export const ProductImagesList: any = [
  {
    code: 1,
    image: '1',
    icon: 1,
    description: 'INCENDIO',
  },
  {
    code: 2,
    image: '2',
    icon: 2,
    description: 'TRANSPORTES',
  },
  {
    code: 3,
    image: '3',
    icon: 3,
    description: 'SEGURO TECNICO',
  },
  {
    code: 4,
    image: '4',
    icon: 4,
    description: 'AUTOMOTORES',
  },
  {
    code: 5,
    image: '5',
    icon: 5,
    description: 'CRISTALES',
  },
  {
    code: 6,
    image: '6',
    icon: 6,
    description: 'ROBO',
  },
  {
    code: 7,
    image: '7',
    icon: 7,
    description: 'RESPONSABILIDAD CIVIL',
  },
  {
    code: 8,
    image: '8',
    icon: 8,
    description: 'GANADO',
  },
  {
    code: 9,
    image: '9',
    icon: 9,
    description: 'CAUCION',
  },
  {
    code: 10,
    image: '10',
    icon: 10,
    description: 'GRANIZO',
  },
  {
    code: 11,
    image: '11',
    icon: 11,
    description: 'COMBINADO FAMILIAR (Hogar)',
  },
  {
    code: 12,
    image: '12',
    icon: 12,
    description: 'ACCIDENTES PERSONALES',
  },
  {
    code: 13,
    image: '13',
    icon: 13,
    description: 'PASAJEROS TRANSPORTADOS',
  },
  {
    code: 14,
    image: '14',
    icon: 14,
    description: 'AERONAVEGACION',
  },
  {
    code: 15,
    image: '15',
    icon: 15,
    description: 'RIESGOS VARIOS (ej. Movilidad)',
  },
  {
    code: 16,
    image: '16',
    icon: 16,
    description: 'ACCIDENTES DEL TRABAJO',
  },
  {
    code: 17,
    image: '17',
    icon: 17,
    description: 'VIDA OBLIGATORIO',
  },
  {
    code: 18,
    image: '18',
    icon: 18,
    description: 'VIDA COLECTIVO',
  },
  {
    code: 19,
    image: '19',
    icon: 19,
    description: 'VIDA INDIVIDUAL',
  },
  {
    code: 20,
    image: '20',
    icon: 20,
    description: 'PERDIDA DE BENEFICIO',
  },
  {
    code: 21,
    image: '21',
    icon: 21,
    description: 'ENFERMEDADES CRITICAS',
  },
  {
    code: 22,
    image: '22',
    icon: 22,
    description: 'CASCOS  (Embarcaciones)',
  },
  {
    code: 25,
    image: '25',
    icon: 25,
    description: 'INTEGRAL DE COMERCIO (Pyme)',
  },
  {
    code: 27,
    image: '27',
    icon: 27,
    description: 'SALUD',
  },
  {
    code: 44,
    image: '14',
    icon: 14,
    description: 'SALDO DEUDOR',
  },
  {
    code: 45,
    image: 'default',
    icon: 28,
    description: 'SEPELIO COLECTIVO',
  },
  {
    code: 46,
    image: '11',
    icon: 11,
    description: 'DESEMPLEO',
  },
  {
    code: 47,
    image: '17',
    icon: 17,
    description: 'PREVISIONAL',
  },
  {
    code: 48,
    image: 'default',
    icon: 23,
    description: 'DOTAL',
  },
  {
    code: 49,
    image: '25',
    icon: 25,
    description: 'DOTAL RENOVACIONES',
  },
  {
    code: 50,
    image: '125',
    icon: 125,
    description: 'FONDO FUTURO',
  },
  {
    code: 51,
    image: '12',
    icon: 12,
    description: 'ACCIDENTES PERSONALES',
  },
  {
    code: 52,
    image: '18',
    icon: 18,
    description: 'VIDA COLECTIVO',
  },
  {
    code: 53,
    image: '27',
    icon: 27,
    description: 'SALUD',
  },
];
